import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import css from './InitialHint.css';
const phoneIcon = (React.createElement("svg", { width: "49", height: "60", viewBox: "0 0 49 60", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.3333 0.666687H43C45.9333 0.666687 48.3333 3.06669 48.3333 6.00002V54C48.3333 56.9333 45.9333 59.3334 43 59.3334H16.3333C13.4 59.3334 11 56.9333 11 54V46H16.3333V51.3334H43V8.66669H16.3333V14H11V6.00002C11 3.06669 13.4 0.666687 16.3333 0.666687ZM4.22663 27.12L11.0266 33.92L26.7866 18.1067L30.1733 21.4934L11 40.6667L0.839966 30.5067L4.22663 27.12Z", fill: "currentColor" })));
const InitialHint = ({ className }) => {
    const { t, i18n } = useTranslation('Account');
    return (React.createElement("div", { className: cn(css.container, className) },
        React.createElement("div", { className: css.title }, t('Check-in conditions')),
        React.createElement("div", { className: css.icon }, phoneIcon),
        React.createElement("ul", { className: css.conditions }, [...Array(10)].map((_, index) => {
            const key = `CheckinConditions_${index}`;
            const isExistTranslate = i18n.exists(key, { ns: 'Account' });
            if (!isExistTranslate || !t(key).trim()) {
                return null;
            }
            return React.createElement("li", { key: index, dangerouslySetInnerHTML: { __html: t(key) } });
        }))));
};
export default InitialHint;
